import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'historico-canais',
	templateUrl: './historico-canais.component.html',
	styleUrls: ['./historico-canais.component.scss']
})
export class HistoricoCanaisComponent {

	@Input() canal: any = {};

	constructor(public activeModal: NgbActiveModal) { }
}



// WEBPACK FOOTER //
// ./src/app/components/historico-canais/historico-canais.component.ts